import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Providers } from '../../app/providers/query-client';
import AcompanharPage from './pages/AcompanharPage';
import VagaPublicaPage from './pages/VagaPublicaPage';
import VagasPublicasPage from './pages/VagasPublicasPage';

/**
 * Portal público de vagas.
 *
 * Roteador próprio, montado **antes** do gate de autenticação do `App`
 * (mesmo caminho de `/reset-password`): o candidato não tem sessão, e
 * passar pelo `AppRouter` exigiria um `user` que não existe. Sem
 * `MainLayout`, sem sidebar e sem o header do app — a área é externa.
 *
 * `/vagas/acompanhar` vem antes de `/vagas/:id` porque, na ordem
 * inversa, "acompanhar" seria capturado como id de vaga.
 */
export function PortalRouter(): React.ReactElement {
  return (
    <Providers>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/vagas" element={<VagasPublicasPage />} />
          <Route path="/vagas/acompanhar" element={<AcompanharPage />} />
          <Route path="/vagas/:id" element={<VagaPublicaPage />} />
          <Route path="*" element={<Navigate to="/vagas" replace />} />
        </Routes>
      </BrowserRouter>
    </Providers>
  );
}
